import React, { useEffect, useState } from "react";
import { Consume } from "../Context/Consumer";
import { TransContext, ConstraintsContext } from "../Context";
import config from "../common/config";
import { getData, googleAnalyticsEventTracking } from "../common";
import Loader from "./Loader";

const SponsorsAd = (props) => {
  let constraints = props.ConstraintsData?.data;
  let [sponsorsList, setSponsorsList] = useState(null);
  let apiParams = {
    endPoint: config.WebConfig[config.APINames.Sponsors]
      ? (
          config.FEEDBASEPATH + config.WebConfig[config.APINames.Sponsors]
        ).replace("{{tourId}}", config.tourId) +
        "?v=" +
        constraints?.BannerVersion
      : config.APIBASEPATH +
        "sponsors/link_data_" +
        config.tourId +
        "?v=" +
        constraints?.BannerVersion,
    type: "GET",
    name: config.APINames.Sponsors,
    params: "",
  };
  useEffect(() => {
    getData(
      apiParams,
      (resp) => {
        setSponsorsList(resp.Data.Value);
      },
      (resp) => {
        console.log(resp);
      }
    );
  }, []);

  return (
    <>
      {sponsorsList === null ? (
        <div
          className="si-main__container--fluid"
          style={{ position: "relative", height: "100%" }}
        >
          <Loader
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      ) : (
        <div className="si-ad">
          <div className="si-adImagesBox">
            {sponsorsList.map((el) => {
              if (el.BannerLink !== "") {
                const { action, category, label } =
                  config.trackclickEvents["sponsor" + el.Position];
                return (
                  <a
                    href={el.AdvertLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={el.Position}
                    onClick={() => {
                      googleAnalyticsEventTracking(action, category, label);
                    }}
                  >
                    <img src={el.BannerLink} alt={el.ImageName} />
                  </a>
                );
              }
            })}
          </div>
        </div>
      )}
      {/* <div className='si-ad'>
				<picture>
					<source
						media='(min-width:768px)'
						srcset={`${config.IMG_BASE}ad-banner.jpg?v=${config.WebConfig.imgVersion}`}
					/>
					<img
						src={`${config.IMG_BASE}ad-banner--mob.jpg?v=${config.WebConfig.imgVersion}`}
					/>
				</picture>
			</div> */}
    </>
  );
};

export default Consume(SponsorsAd, [TransContext, ConstraintsContext]);
